import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import FullLogo from '../../assets/full-logo.svg';
import { ReactComponent as ArrowBack } from '../../assets/arrow-back.svg';

import OwnerContext from '../../context/OwnerContext';
import { isOwnerStatusValid } from '../../helpers/AuthOwnerHelper';
import { OwnerHttpServiceAuth } from '../../services/ApiServices';
import SpinnerInline from '../../components/SpinnerInline';
import OwnerFooter from '../../components/OwnerFooter';
import { OwnerLoginStage } from '../../helpers/EnumsInternal';


type HeaderProps = {
    setOwnerLoginStage: Function,
    inputMobileOrEmail: string,
    loginCodeId: number
}

function OwnerExternRefresh(props: HeaderProps) {
    let {setOwnerLoginStage, inputMobileOrEmail, loginCodeId} = props;

    const ownerLoginObject = useContext(OwnerContext);
    const history = useHistory();
    const [ consentsRefreshRequested, setConsentsRefreshRequested ] = useState<boolean>(false);


    useEffect(() => {
        if (!consentsRefreshRequested) {
            // Check ownerStatus exists and is not expired.
            if (!isOwnerStatusValid(ownerLoginObject)) {
                history.push('/unauth');
            }
            
            if (ownerLoginObject !== null && ownerLoginObject.ownerStatus !== null) {
                setConsentsRefreshRequested(true);
                OwnerHttpServiceAuth(ownerLoginObject, 'owners/refresh', 'POST',
                    { LoginCodeId:loginCodeId, mobilePhoneOrEmailAddress:inputMobileOrEmail })
                .then(result => {
                    if (result.status === 401 || result.status === 403)  // Unauthorised / Forbidden
                        history.push('/unauth');
                    else    // All other cases, show consents - even if refresh service does not succeed.
                        history.push('/consents');
                })
                .catch(e => {
                    console.log("Something fishy happened: " + e);
                    history.push('/consents');
                });     
            }
        }
    }, [ ownerLoginObject, history, consentsRefreshRequested, loginCodeId, inputMobileOrEmail ]);


    return (
        <div className="login-container login-consentowner">
            <div className="content">
                <div className="top d-flex align-items-center justify-content-between">
                    <Link className="logo" to="/"><img src={FullLogo} alt="Logo" /></Link>
                    <div className="d-flex link-back" onClick={() => setOwnerLoginStage(OwnerLoginStage.Start)}><ArrowBack />Start forfra</div>
                </div>

                <div className="login-area">
                    <div className="inner">
                        <h1>Vi er i gang...</h1>
                        <br />

                        <h3>Vent venligst mens vi finder dine samtykker.</h3>
                        <br />
                        
                        <div className="text-center"><SpinnerInline /></div>

                        <br /><br /><br />

                        <div className="terms">
                            <p>MitSamtykke er til for DIT samtykkes skyld. Se vores brugsbetingelser <a href="https://www.mitsamtykke.dk/brugervilkaar/" target="_blank" rel="noopener noreferrer">her</a></p>
                        </div>
                    </div>
                </div>

                <OwnerFooter />
            </div>
            <div className="image-container"></div>
        </div>
    );
}

export default OwnerExternRefresh;
